const NS_STATES_CANNABIS = ["Dysregulated", "Anxious", "Neutral", "Grounded", "Regulated"];
const NS_STATES_MUSHROOM = ["Open", "Tender", "Integrating", "Grounded", "Regulated"];

function NervousSystemTracking({ valueBefore, valueAfter, onChangeBefore, onChangeAfter, isBefore, isDuring, isAfter, isMushroom }) {
  const states = isMushroom ? NS_STATES_MUSHROOM : NS_STATES_CANNABIS;
  const beforeLabel = isMushroom ? "Before Journey" : "Before Session";
  const afterLabel = isMushroom ? "After Journey" : "After Session";

  return (
    <div className="NervousSystemTracking" style={{ marginTop: "16px" }}>
      <h3 style={{ fontSize: "14px", fontWeight: "500", marginTop: "8px", marginBottom: "8px" }}>
      </h3>
      {(isBefore || isDuring || isAfter) && (
        <label>
          {beforeLabel}
          <select
            value={valueBefore || ""}
            onChange={(e) => onChangeBefore(e.target.value)}
          >
            <option value="">-- Select state --</option>
            {states.map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </label>
      )}
      {(isAfter || isDuring) && (
        <label>
          {afterLabel}
          <select
            value={valueAfter || ""}
            onChange={(e) => onChangeAfter(e.target.value)}
          >
            <option value="">-- Select state --</option>
            {states.map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
}

export default NervousSystemTracking;